module.exports = "//static.hsappstatic.net/salesImages/static-1.403/messages/email-chat-bubble.png"